'use strict';

import React from 'react';
import PropTypes from 'prop-types';

export default class EventCenterField extends React.Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }
  }

  render() {
    return (
      <input
        value={this.state.value}
        type="hidden"
        name="event[center]"
        id="event_center" />
    );
  }
}
